const pinkColor = 'rgba(255, 240, 255, 1)'
const whiteColor = 'rgba(255, 255, 255, 1)'
const blackColor = 'rgba(0, 0, 0, 1)'
const grayColor = 'rgba(125, 129, 142, 1)'
const lightGrayColor = 'rgba(217, 217, 217, 1)';
const violetColor = 'rgba(110, 90, 180, 1)'
const lightVioletColor = "rgba(230, 195, 230, 1)";
const lightBlackColor = 'rgba(15, 15, 25, 1)'

export {
    pinkColor,
    whiteColor,
    blackColor,
    grayColor,
    violetColor,
    lightVioletColor,
    lightBlackColor,
    lightGrayColor
}
